module.exports = __webpack_public_path__ + "components/collaborations-header/static/header--medium-c6458db6988b0910df0765e3cb3430e4.jpg";